import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  background: ${(props) => props.theme.notificationBackground};
  padding: 0.2rem;
  border-radius: 50%;

  .icon {
    svg path {
      stroke: ${(props) => props.theme.notificationIcon};
    }
  }

  p {
    position: absolute;
    top: -0.4rem;
    right: -0.4rem;
    background: ${(props) => props.theme.error};
    width: 1rem;
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: ${(props) => props.theme.textWhite};
  }
`;
